import { CircularProgress, Menu, Stack, type MenuProps } from "@mui/material";
import { useEffect, useRef, useState, type FC } from "react";
import { BasicButton } from "../generic-components/button/Button";
import { useSkills } from "../../queries/skills.query";
import "./../teams-select/TeamsSelect.scss";
import { OneTeamChip } from "../teams-select/OneTeam";

interface SkillsSelectProps {
    onClose?: () => void;
    anchorEl: EventTarget | null | boolean;
    value?: string[];
    onSave?: (skills: string[], hasVehicle: boolean) => void;
    menuProps?: MenuProps;
    containerClass?: string;
    showSaveButton?: boolean;
    onChange?: (selectedSkills: string[]) => void;
    menu?: boolean;
}

export const SkillsSelect: FC<SkillsSelectProps> = (props) => {
    const {
        onSave = () => { },
        onClose = () => { },
        onChange = () => { },
        anchorEl = null,
        value,
        menuProps,
        containerClass,
        showSaveButton = true,
        menu = true,
    } = props;
    const [selectedSkills, setSelectedSkills] = useState<string[]>(value || []);
    const { skillsAndVehicles, isLoading } = useSkills();
    const [hasVehicle, setHasVehicle] = useState<boolean>(false);

    useEffect(() => {
        onChange(selectedSkills);
    }, [JSON.stringify(selectedSkills)]);

    function handleChange(teamId: string, checked: boolean) {
        setSelectedSkills((prev) => {
            let teams = structuredClone(prev);
            if (checked) {
                teams.push(teamId);
            } else {
                teams = teams.filter((id) => teamId !== id);
            }
            return teams;
        });
    }

    // If (isLoading) return <CircularProgress />;

    return (
        <>
            {menu ?
                <Menu
                    {...menuProps}
                    classes={{ paper: `${containerClass} menu-container`, list: "menu-list-container" }}
                    slotProps={{ paper: { sx: { borderRadius: "20px", overflowY: "auto" } } }}
                    onClose={() => {
                        onClose();
                        setSelectedSkills([]);
                    }}
                    open={!!anchorEl}
                    anchorEl={anchorEl as HTMLElement}
                    anchorOrigin={{
                        horizontal: "center",
                        vertical: "top",
                    }}
                    transformOrigin={{
                        horizontal: "center",
                        vertical: "bottom",
                    }}
                >
                    <Stack className="overflow-container">
                        {skillsAndVehicles?.skills?.map((skill) => (
                            <OneTeamChip
                                key={skill.id}
                                team={{ ...skill, name: skill.category === "physical" ? "יכולת פיזית " + skill.name : skill.name }}
                                checked={selectedSkills?.includes(skill.id)}
                                onChange={handleChange}
                            />
                        ))}
                    </Stack>
                    {showSaveButton &&
                        <Stack
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            width="100%"
                            paddingBottom="0.5rem"
                        >
                            <BasicButton onClick={() => { onSave(selectedSkills, hasVehicle); }} text="שמירה" />
                        </Stack>}
                </Menu> :
                <>
                    {!!anchorEl && <Stack className="menu-container">
                        <Stack className="menu-list-container">
                            <Stack className="overflow-container" sx={{ maxHeight: "40vh" }}>
                                {skillsAndVehicles?.skills?.map((skill) => (
                                    <OneTeamChip
                                        tooltip={false}
                                        key={skill.id}
                                        team={{ ...skill, name: skill.category === "physical" ? "יכולת פיזית " + skill.name : skill.name }}
                                        checked={selectedSkills?.includes(skill.id)}
                                        onChange={handleChange}
                                    />
                                ))}
                            </Stack>
                            {showSaveButton && <Stack
                                display="flex"
                                justifyContent="center"
                                alignItems="end"
                                width="95%"
                            >
                                <BasicButton onClick={() => { onSave(selectedSkills, hasVehicle); }} text="שמירה" />
                            </Stack>}
                        </Stack>
                    </Stack>}
                </>}
        </>

    );
};
